import Switch from 'react-switch';
import { KEYS } from '../utils/storage';

// The build stamp is a unix timestamp in production builds, 'dev' locally. Read at render
// time because index.js sets it after the modules have been imported.
const getBuildLabel = () => {
  const stamp = window.__POKETTA_BUILD_STAMP__ || 'dev';
  if (!/^\d+$/.test(stamp)) return stamp;
  const built = new Date(Number(stamp) * 1000).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  return `${stamp} (${built})`;
};

export function SettingsModal({ isOpen, onClose, isHardMode, onHardModeChange, isDarkMode, onDarkModeChange, showVariantCards, onShowVariantCardsChange, useClassicalCards, onUseClassicalCardsChange, isWinner, hasInteracted }) {
  return (
    <div className={`modal settings-modal ${isOpen ? 'open' : 'closed'}`}>
      <div className='modal-overlay' onClick={onClose}></div>
      <div className='modal-content'>
        <h2>Settings</h2>
        <p>Tweak Poqueta to your preferences.</p>

        <hr />

        <div className='example'>
          <h4>Change Difficulty</h4>
          <p>
            <small>
              Hard mode stops the required hands lighting up as they're found. You can only change
              the difficulty <b>before</b> you make any moves.
            </small>
          </p>
          <label className='switch'>
            <Switch
              onChange={(checked) => {
                onHardModeChange(checked);
                localStorage.setItem(KEYS.IS_HARD_MODE, JSON.stringify(checked));
              }}
              onColor='#52141f'
              checked={isHardMode}
              disabled={isWinner || hasInteracted}
              height={18}
              width={36}
              handleDiameter={18}
            />
            <span>Toggle Hard Mode  <small><br />{hasInteracted ? 'locked for today' : 'locks after 1st move'}</small></span>
          </label>
        </div>

        <div className='example'>
          <h4>Dark Mode</h4>
          <p>
            <small>
              Game too dark or too bright?
            </small>
          </p>
          <label className='switch'>
            <Switch
              onChange={(checked) => {
                onDarkModeChange(checked);
                localStorage.setItem(KEYS.IS_DARK_MODE, JSON.stringify(checked));
              }}
              onColor='#52141f'
              checked={isDarkMode}
              height={18}
              width={36}
              handleDiameter={18}
            />
            <span>Toggle Dark Mode</span>
          </label>
        </div>

        <div className='example'>
          <h4>Display Special Cards</h4>
          <p>
            <small>
              Display your unlocked card variants in game!
            </small>
          </p>
          <label className='switch'>
            <Switch
              onChange={(checked) => {
                onShowVariantCardsChange(checked);
                localStorage.setItem(KEYS.SHOW_VARIANT_CARDS, JSON.stringify(checked));
              }}
              onColor='#52141f'
              checked={showVariantCards}
              height={18}
              width={36}
              handleDiameter={18}
            />
            <span>Display special cards in puzzles</span>
          </label>
        </div>

        <div className='example'>
          <h4>Classic Deck</h4>
          <div className='grid' style={{ margin: '0 auto' }}>
            {['th', '7c', 'or', 'kc', 'ah'].map((card, j) => (
              <div className='card' style={{'opacity': 1 }} key={`example_classic_card_${j}`}>
                <img alt='' className='front' src={`./assets/simoncards/${card}.png`} />
              </div>
            ))}
          </div>
          <p>
            <small>
              Switch card art to the classic Spiers deck.
            </small>
          </p>
          <label className='switch'>
            <Switch
              onChange={(checked) => {
                onUseClassicalCardsChange(checked);
                localStorage.setItem(KEYS.USE_CLASSICAL_CARDS, JSON.stringify(checked));
              }}
              onColor='#52141f'
              checked={useClassicalCards}
              height={18}
              width={36}
              handleDiameter={18}
            />
            <span>Use classic card art</span>
          </label>
        </div>

        <hr />

        <div className='modal-buttons'>
          <button onClick={onClose}>Return to Puzzle</button>
        </div>

        <p><small>Poqueta returns <span style={{ display: 'inline-block' }}>with a new puzzle every day.</span></small></p>

        <p>
          <small className='tiny'>
            Created by <a href='https://github.com/bogstandard/'>Bogstandard</a><br />
            Art by <b>Simon Spiers</b><br />
            Version {getBuildLabel()}
          </small>
        </p>
      </div>
    </div>
  );
}
